import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
} from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ArticleIcon from "@mui/icons-material/Article";
import HelpIcon from "@mui/icons-material/Help";
import GroupIcon from "@mui/icons-material/Group";
import { BASE_URL } from "./../../global";
import Dashboard_background from "../image/client.jpg";
import WelcomeBanner from "../image/welcome.png";
import axiosWithToken from "../../utils/components/axiosTokenConfig";

import EditWrap from "../commonComponent/editWrap";
import { BarGraph } from "./Graphs";
import RotateLeftOutlinedIcon from "@mui/icons-material/RotateLeftOutlined";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import {
  CustomCard,
  WorkReportWidget,
  RecentInwardsWidget,
  UpcomingDueDatesWidget,
  DashboardWidgetCard,
  DashboardActionPill,
  DashboardSectionHeader,
} from "./DashboardComponents";



export default function Dashboard(props) {

  const [userType] = React.useState(localStorage.getItem("type"));
  const [userId] = React.useState(localStorage.getItem("id"));
  const [counts, setCounts] = useState({
    todaysClientsCount: 0,
    todaysSrfsCount: 0,
    todaysCertificatesCount: 0,
    todaysRenewalsCount: 0,
    overAllActiveIncCount: 0,
    overAllRenewalCount: 0,
    overAllClientDueCount: 0,
    todayClientDueCount: 0,
    masterRenewalCount: 0,
    selfJobs: 0,
    assignedJobs: 0,
    pendingJobs: 0,
    completedJobs: 0,
    engineerRenewals: 0,
  });
  const [clientId] = React.useState(localStorage.getItem("clientId"));
  const [disciplineID] = React.useState(localStorage.getItem("disciplineID"));
  const [moduleAccess] = React.useState(
    (localStorage.getItem("modules") || "")
      ?.split(",")
      ?.map((numStr) => Number(numStr))
      .filter((num) => !isNaN(num))
  );
  const [datashheetCalibratedPending, setDatashheetCalibratedPending] = useState(0);
  const [certificateApprovedCount, setCertificateApprovedCount] = useState(0);

  const [overallMonthlyStats, setOverallMonthlyStats] = useState({
    clients: { current: 0, last: 0, total: 0 },
    certs: { current: 0, last: 0, total: 0 },
    renewals: { current: 0, last: 0, total: 0 },
    masters: { current: 0, last: 0, total: 0 },
  });

  const isAdmin = Number(userType) === 1 || Number(userType) === 4;

  const [engineerBarData, setEngineerBarData] = useState({
    labels: ["Assigned Jobs", "Self Jobs"],
    datasets: [
      {
        label: "Completed",
        data: [0, 0], // both's Completed
        backgroundColor: "rgba(25, 118, 210, 1)",
        borderRadius: 4,
        stack: "Stack 0",
      },
      {
        label: "Pending",
        data: [0, 0], // boths Pending
        backgroundColor: "rgba(189, 189, 189, 0.4)",
        borderRadius: 4,
        stack: "Stack 0",
      },
    ],
  });

  const [performanceData, setPerformanceData] = useState({
    topUser: { name: "N/A", count: 0 },
    minUser: { name: "N/A", count: 0 },
  });

  const [approverPerformanceData, setApproverPerformanceData] = useState({
    topUser: { name: "N/A", count: 0 },
    minUser: { name: "N/A", count: 0 },
  });

  const [workReportTimeframe, setWorkReportTimeframe] = useState("today");

  const [recentInwardsList, setRecentInwardsList] = useState([]);
  const [upcomingDueDatesList, setUpcomingDueDatesList] = useState([]);

  const formatShortDate = (dateVal) => {
    if (!dateVal) return "-";
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return String(dateVal);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = String(d.getDate()).padStart(2, "0");
    const m = months[d.getMonth()];
    const y = d.getFullYear();
    return `${day}-${m}-${y}`;
  };

  const fetchRecentInwards = async () => {
    try {
      const query = `
        SELECT 
          s.id,
          s.serviceReqNumber,
          COALESCE(c.companyName, 'Client') as companyName,
          (SELECT COUNT(*) FROM srfInstruments si WHERE si.srfsId = s.id AND si.status = 1) as totalInstruments,
          COALESCE(s.receiptDate, s.entryDate) as receivedDate,
          s.status
        FROM srfs s
        LEFT JOIN clients c ON s.clientId = c.id
        WHERE s.status = 1 ${userType == 3 ? `AND s.clientId = ${clientId}` : ""}
        ORDER BY s.id DESC
        LIMIT 5
      `;
      const res = await axiosWithToken.post(BASE_URL + "dynamic", { query });
      if (res.data && res.data.length > 0) {
        const rows = res.data.map((r) => {
          let statusLabel = "In Progress";
          const s = String(r.status);
          if (s === "2") statusLabel = "Completed";
          else if (s === "0") statusLabel = "Pending";
          return {
            id: r.id,
            inwardNo: r.serviceReqNumber || `IN/${r.id}`,
            client: r.companyName || "Client",
            totalInstruments: Number(r.totalInstruments) || 1,
            date: formatShortDate(r.receivedDate),
            status: statusLabel,
          };
        });
        setRecentInwardsList(rows);
      } else {
        setRecentInwardsList([]);
      }
    } catch (err) {
      console.error("fetchRecentInwards error:", err);
    }
  };

  const fetchUpcomingDueDates = async () => {
    try {
      const clientFilter = userType == 3 ? `AND cert.clientId = ${clientId}` : "";
      const query = `
        SELECT 
          cert.id,
          COALESCE(cert.companyName, 'Client') as client,
          COALESCE(NULLIF(TRIM(cert.requestedname), ''), NULLIF(TRIM(cert.instrumentName), ''), '-') as instrumentName,
          COALESCE(NULLIF(TRIM(REPLACE(REPLACE(cert.ranges, '#', ''), '|', ' to ')), ''), '-') as \`range\`,
          COALESCE(NULLIF(TRIM(REPLACE(cert.lc, '#', ' ')), ''), '-') as lc,
          COALESCE(NULLIF(TRIM(cert.DUCID), ''), NULLIF(TRIM(cert.identificationNo), ''), '-') as ducId,
          COALESCE(NULLIF(TRIM(cert.serialNumber), ''), NULLIF(TRIM(cert.srnNo), ''), '-') as serialNo,
          cert.calibrationDate,
          cert.nextDueDate,
          DATEDIFF(cert.nextDueDate, CURDATE()) as daysLeft
        FROM (
          SELECT * FROM certificatesView AS cert 
          WHERE cert.nextDueDate IS NOT NULL 
            AND cert.status != -1 
            AND cert.renewalStatus = 1
            AND DATE(cert.nextDueDate) >= CURDATE()
            ${clientFilter}
          UNION ALL 
          SELECT * FROM certificatesView_hist AS cert 
          WHERE cert.nextDueDate IS NOT NULL 
            AND cert.status != -1 
            AND cert.renewalStatus = 1
            AND DATE(cert.nextDueDate) >= CURDATE()
            ${clientFilter}
        ) AS cert
        ORDER BY cert.nextDueDate ASC
        LIMIT 5
      `;
      const res = await axiosWithToken.post(BASE_URL + "dynamic", { query });
      if (res.data && res.data.length > 0) {
        const rows = res.data.map((r) => ({
          id: r.id,
          client: r.client || '-',
          instrumentName: r.instrumentName || '-',
          range: r.range || '-',
          lc: r.lc || '-',
          ducId: r.ducId || '-',
          serialNo: r.serialNo || '-',
          calibDate: formatShortDate(r.calibrationDate),
          dueDate: formatShortDate(r.nextDueDate),
          daysLeft: Math.max(0, Number(r.daysLeft) || 0),
        }));
        setUpcomingDueDatesList(rows);
      } else {
        setUpcomingDueDatesList([]);
      }
    } catch (err) {
      console.error("fetchUpcomingDueDates error:", err);
    }
  };

  const getCertificateNotApproved = () => {
    let query = {
      query: `SELECT count(*) as no_of_rows FROM certificatesView where status != -1 and calibratedby is NOT NULL and approvedby is NULL and discID IN (${disciplineID})`,
    };
    axiosWithToken
      .post(BASE_URL + `dynamic`, query)
      .then((res) => {
        let resCount = res.data[0].no_of_rows;
        setCertificateApprovedCount(resCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDatasheetCalibrated = () => {
    let query = {
      query: `SELECT COUNT(*) as no_of_rows FROM datasheets WHERE assignedUser = ${userId} AND calibratedby IS NULL AND status = 1`,
    };
    axiosWithToken
      .post(BASE_URL + `dynamic`, query)
      .then((res) => {
        let resCount = res.data[0].no_of_rows;
        setDatashheetCalibratedPending(resCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  // Admin & QM dashboard data (Work Report, Recent Inwards, Upcoming Due Dates)
  // Only depends on userType so it runs once on load and does NOT re-trigger when currentRole updates
  useEffect(() => {
    if (userType == 1 || userType == 4) {
      fetchPerformance(workReportTimeframe);
      fetchApproverPerformance(workReportTimeframe);

      // Recent inwards and upcoming due dates for Admin / QM based on module access
      if (isAdmin || moduleAccess.includes(3)) {
        fetchRecentInwards();
      }
      if (isAdmin || moduleAccess.includes(12)) {
        fetchUpcomingDueDates();
      }
    }
  }, [userType]);

  // Role-specific badge request counts (runs when currentRole loads/switches)
  useEffect(() => {
    if (moduleAccess.includes(5) && props.rolesInfo?.currentRole?.id == 2) {
      getCertificateNotApproved();
    }

    // Engineer
    if (userType == 2 && props.rolesInfo?.currentRole?.id == 1) {
      getDatasheetCalibrated();
    }
  }, [userType, props.rolesInfo?.currentRole?.id]);


  const fetchApproverPerformance = (timeframe) => {
    const currentUserName = localStorage.getItem("userName");

    let subquery = "";
    if (timeframe === "today") {
      subquery = `
        SELECT approvedby, COUNT(id) as approvalCount
        FROM certificatesView
        WHERE approvedby IS NOT NULL 
          AND status != -1
          AND lastModified >= CURDATE() AND lastModified < CURDATE() + INTERVAL 1 DAY
        GROUP BY approvedby
      `;
    } else if (timeframe === "monthly") {
      subquery = `
        SELECT approvedby, COUNT(id) as approvalCount
        FROM certificatesView
        WHERE approvedby IS NOT NULL 
          AND status != -1
          AND lastModified >= DATE_FORMAT(CURDATE(), '%Y-%m-01') AND lastModified < DATE_FORMAT(CURDATE() + INTERVAL 1 MONTH, '%Y-%m-01')
        GROUP BY approvedby
      `;
    } else {
      // Overall: direct indexed single-table scan on certificates (bypasses 7-table view for 10-20 lakh rows)
      subquery = `
        SELECT approvedby, COUNT(id) as approvalCount
        FROM certificates
        WHERE approvedby IS NOT NULL 
          AND status != -1
        GROUP BY approvedby
      `;
    }

    const query = {
      query: `SELECT 
                u.id,
                u.userName,
                c.approvalCount
              FROM users u
              INNER JOIN (${subquery}) c ON c.approvedby = u.id
              WHERE (u.userName != 'bfi' OR '${currentUserName}' = 'bfi')
              ORDER BY c.approvalCount DESC;`
    };

    axiosWithToken.post(BASE_URL + "dynamic", query)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setApproverPerformanceData({
            topUser: { name: res.data[0].userName, count: res.data[0].approvalCount },
            minUser: { name: res.data[res.data.length - 1].userName, count: res.data[res.data.length - 1].approvalCount },
          });
        } else {
          setApproverPerformanceData({
            topUser: { name: "N/A", count: 0 },
            minUser: { name: "N/A", count: 0 },
          });
        }
      })
      .catch((err) => console.log("Approver Performance error: ", err));
  };

  const fetchPerformance = (timeframe) => {
    const currentUserName = localStorage.getItem("userName");

    let subquery = "";
    if (timeframe === "today") {
      subquery = `
        SELECT calibratedby, COUNT(id) as calibrationCount
        FROM certificatesView
        WHERE calibratedby IS NOT NULL 
          AND status != -1
          AND lastModified >= CURDATE() AND lastModified < CURDATE() + INTERVAL 1 DAY
        GROUP BY calibratedby
      `;
    } else if (timeframe === "monthly") {
      subquery = `
        SELECT calibratedby, COUNT(id) as calibrationCount
        FROM certificatesView
        WHERE calibratedby IS NOT NULL 
          AND status != -1
          AND lastModified >= DATE_FORMAT(CURDATE(), '%Y-%m-01') AND lastModified < DATE_FORMAT(CURDATE() + INTERVAL 1 MONTH, '%Y-%m-01')
        GROUP BY calibratedby
      `;
    } else {
      // Overall: direct indexed scan on datasheets (bypasses 7-table view for 10-20 lakh rows)
      subquery = `
        SELECT calibratedby, COUNT(id) as calibrationCount
        FROM datasheets
        WHERE calibratedby IS NOT NULL 
          AND status = 1
        GROUP BY calibratedby
      `;
    }

    const query = {
      query: `SELECT 
                u.id,
                u.userName,
                c.calibrationCount
              FROM users u
              INNER JOIN (${subquery}) c ON c.calibratedby = u.id
              WHERE (u.userName != 'bfi' OR '${currentUserName}' = 'bfi')
              ORDER BY c.calibrationCount DESC;`
    };

    axiosWithToken.post(BASE_URL + "dynamic", query)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setPerformanceData({
            topUser: { name: res.data[0].userName, count: res.data[0].calibrationCount },
            minUser: { name: res.data[res.data.length - 1].userName, count: res.data[res.data.length - 1].calibrationCount },
          });
        } else {
          setPerformanceData({
            topUser: { name: "N/A", count: 0 },
            minUser: { name: "N/A", count: 0 },
          });
        }
      })
      .catch((err) => console.log("Performance fetching error: ", err));
  };

  /////////////////////////////DashboardData////////////////////////

  const fetchCountwihtoutDate = async (table, condition) => {
    try {
      const url = `${BASE_URL}dynamic`;
      const query = `SELECT COUNT(*) as count FROM ${table} WHERE ${condition}`;
      const response = await axiosWithToken.post(url, { query });
      return Number(response.data?.[0]?.count) || 0;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

  const fetchDataCounts = async () => {
    if (!userType || (userType != 1 && userType != 4 && userType != 2)) return;
    try {
      if (userType == 1 || userType == 4) {
        // Admin & QM - Optimized for 10-20 lakh+ rows via indexed base tables, early filtering, and sargable ranges
        const multiMonthlyStatsQuery = {
          query: `
            SELECT 'clients' as category,
              COUNT(*) as total,
              SUM(CASE WHEN lastModified >= DATE_FORMAT(CURDATE(), '%Y-%m-01') AND lastModified < DATE_FORMAT(CURDATE() + INTERVAL 1 MONTH, '%Y-%m-01') THEN 1 ELSE 0 END) as curr,
              SUM(CASE WHEN lastModified >= DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 1 MONTH), '%Y-%m-01') AND lastModified < DATE_FORMAT(CURDATE(), '%Y-%m-01') THEN 1 ELSE 0 END) as last
            FROM clients WHERE status = 1 ${userType == 3 ? `AND id = ${clientId}` : ""}
            UNION ALL
            SELECT 'certs' as category,
              COUNT(*) as total,
              SUM(CASE WHEN c.approvedDate IS NOT NULL
                AND c.approvedDate >= CONVERT_TZ(DATE_FORMAT(CURDATE(), '%Y-%m-01'), '+05:30', '+00:00')
                AND c.approvedDate < CONVERT_TZ(DATE_FORMAT(CURDATE() + INTERVAL 1 MONTH, '%Y-%m-01'), '+05:30', '+00:00')
                THEN 1 ELSE 0 END) as curr,
              SUM(CASE WHEN c.approvedDate IS NOT NULL
                AND c.approvedDate >= CONVERT_TZ(DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 1 MONTH), '%Y-%m-01'), '+05:30', '+00:00')
                AND c.approvedDate < CONVERT_TZ(DATE_FORMAT(CURDATE(), '%Y-%m-01'), '+05:30', '+00:00')
                THEN 1 ELSE 0 END) as last
            FROM certificates c
            JOIN datasheets ds ON ds.id = c.id AND ds.status = 1
            WHERE c.status != -1
              AND c.approvedby IS NOT NULL
              AND ds.totalReadings > 0
              ${userType == 3 ? `AND c.clientId = ${clientId}` : ""}
            UNION ALL
            SELECT 'duc' as category,
              SUM(CASE WHEN nextDueDate IS NOT NULL AND nextDueDate <= CURDATE() THEN 1 ELSE 0 END) as total,
              SUM(CASE WHEN nextDueDate IS NOT NULL AND nextDueDate >= DATE_FORMAT(CURDATE(), '%Y-%m-01') AND nextDueDate < DATE_FORMAT(CURDATE() + INTERVAL 1 MONTH, '%Y-%m-01') THEN 1 ELSE 0 END) as curr,
              SUM(CASE WHEN nextDueDate IS NOT NULL AND nextDueDate >= DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 1 MONTH), '%Y-%m-01') AND nextDueDate < DATE_FORMAT(CURDATE(), '%Y-%m-01') THEN 1 ELSE 0 END) as last
            FROM (
                SELECT nextDueDate, clientId FROM certificates WHERE status != -1 AND renewalStatus = 1 ${userType == 3 ? `AND clientId = ${clientId}` : ""}
                UNION ALL 
                SELECT nextDueDate, clientId FROM certificates_hist WHERE status != -1 AND renewalStatus = 1 ${userType == 3 ? `AND clientId = ${clientId}` : ""}
            ) AS combined
            UNION ALL
            SELECT 'master' as category,
              SUM(CASE WHEN validUpto IS NOT NULL AND validUpto <= CURDATE() + INTERVAL 20 DAY THEN 1 ELSE 0 END) as total,
              SUM(CASE WHEN validUpto >= DATE_FORMAT(CURDATE(), '%Y-%m-01') AND validUpto < DATE_FORMAT(CURDATE() + INTERVAL 1 MONTH, '%Y-%m-01') THEN 1 ELSE 0 END) as curr,
              SUM(CASE WHEN validUpto >= DATE_FORMAT(DATE_SUB(CURDATE(), INTERVAL 1 MONTH), '%Y-%m-01') AND validUpto < DATE_FORMAT(CURDATE(), '%Y-%m-01') THEN 1 ELSE 0 END) as last
            FROM standards WHERE status != -1 AND renewalStatus = 1 ${userType == 3 ? "AND 1=0" : ""}
          `
        };

        const resM = await axiosWithToken.post(BASE_URL + "dynamic", multiMonthlyStatsQuery);
        const statsMap = {};
        resM.data.forEach(row => {
          statsMap[row.category] = { current: row.curr || 0, last: row.last || 0, total: row.total || 0 };
        });
        setOverallMonthlyStats({
          clients: statsMap.clients || { current: 0, last: 0, total: 0 },
          certs: statsMap.certs || { current: 0, last: 0, total: 0 },
          renewals: statsMap.duc || { current: 0, last: 0, total: 0 },
          masters: statsMap.master || { current: 0, last: 0, total: 0 },
        });
      }

      if (userType == 2) {
        // Parallel ultra-optimized queries for Engineer (1 single aggregation for all datasheet metrics + renewals + standards)
        const [
          dsStatsRes,
          engineerRenewals,
          masterRenewalCount
        ] = await Promise.all([
          axiosWithToken.post(BASE_URL + "dynamic", {
            query: `SELECT 
              SUM(CASE WHEN createdby = ${userId} THEN 1 ELSE 0 END) as selfJobs,
              SUM(CASE WHEN assignedUser = ${userId} THEN 1 ELSE 0 END) as assignedJobs,
              SUM(CASE WHEN totalReadings IS NULL OR totalReadings = 0 THEN 1 ELSE 0 END) as pendingJobs,
              SUM(CASE WHEN totalReadings IS NOT NULL AND totalReadings > 0 THEN 1 ELSE 0 END) as completedJobs,
              SUM(CASE WHEN createdby = ${userId} AND (totalReadings IS NOT NULL AND totalReadings > 0) THEN 1 ELSE 0 END) as selfComp,
              SUM(CASE WHEN createdby = ${userId} AND (totalReadings IS NULL OR totalReadings = 0) THEN 1 ELSE 0 END) as selfPend,
              SUM(CASE WHEN assignedUser = ${userId} AND (totalReadings IS NOT NULL AND totalReadings > 0) THEN 1 ELSE 0 END) as assComp,
              SUM(CASE WHEN assignedUser = ${userId} AND (totalReadings IS NULL OR totalReadings = 0) THEN 1 ELSE 0 END) as assPend
            FROM datasheets 
            WHERE status = 1 AND (createdby = ${userId} OR assignedUser = ${userId})`
          }),
          fetchCountwihtoutDate(
            "certificates c JOIN datasheets ds ON ds.id = c.id AND ds.status = 1",
            `c.renewalStatus = 1 AND c.status != -1 AND c.nextDueDate IS NOT NULL AND c.nextDueDate <= CURDATE() AND (ds.createdby = ${userId} OR ds.assignedUser = ${userId})`
          ),
          fetchCountwihtoutDate("standards", "validUpto <= CURDATE() + INTERVAL 20 DAY AND status = 1 AND renewalStatus = 1")
        ]);

        const dsStats = dsStatsRes?.data?.[0] || {};
        const selfJobs = Number(dsStats.selfJobs) || 0;
        const assignedJobs = Number(dsStats.assignedJobs) || 0;
        const pendingJobs = Number(dsStats.pendingJobs) || 0;
        const completedJobs = Number(dsStats.completedJobs) || 0;
        const selfCompleted = Number(dsStats.selfComp) || 0;
        const selfPending = Number(dsStats.selfPend) || 0;
        const assignedCompleted = Number(dsStats.assComp) || 0;
        const assignedPending = Number(dsStats.assPend) || 0;

        setCounts(prev => ({
          ...prev,
          selfJobs,
          assignedJobs,
          pendingJobs,
          completedJobs,
          engineerRenewals,
          masterRenewalCount,
          selfCompleted,
          selfPending,
          assignedCompleted,
          assignedPending,
        }));
      }
    } catch (error) {
      console.error("fetchDataCounts error:", error);
    }

  };

  useEffect(() => {
    fetchDataCounts();
  }, [userType, userId, clientId]);

  // Engineer Bar Graph sync
  useEffect(() => {
    if (userType == 2 && counts) {
      setEngineerBarData(prev => ({
        ...prev,
        datasets: [
          {
            ...prev.datasets[0],
            data: [counts.assignedCompleted || 0, counts.selfCompleted || 0]
          },
          {
            ...prev.datasets[1],
            data: [counts.assignedPending || 0, counts.selfPending || 0]
          }
        ]
      }));
    }
  }, [counts, userType]);

  // Users without dashboard components (Client, Site Incharge, etc.) see ONLY the full dashboard image
  if (userType != 1 && userType != 4 && userType != 2) {
    return (
      <EditWrap>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            style={{
              height: "100%",
              maxHeight: "100%",
              maxWidth: "100%",
              width: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
            src={Dashboard_background}
            alt="dashboard_background"
          />
        </div>
      </EditWrap>
    );
  }

  return (
    <EditWrap>
      <div
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {/* Top Welcome Panoramic Banner for All Users */}
        <Box
          sx={{
            width: "100%",
            position: "relative",
            borderRadius: { xs: "12px", sm: "14px", md: "16px" },
            overflow: "hidden",
            backgroundImage: `linear-gradient(to right, rgba(15, 23, 42, 0.72) 0%, rgba(15, 23, 42, 0.45) 50%, rgba(15, 23, 42, 0.35) 100%), url(${WelcomeBanner})`,
            backgroundSize: "cover",
            backgroundPosition: { xs: "right 22%", sm: "right 28%", md: "center 30%" },
            color: "#ffffff",
            p: {
              xs: "12px 14px",
              sm: "16px 20px",
              md: "18px 28px",
              lg: "20px 32px",
            },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
            justifyContent: "space-between",
            gap: { xs: 0.8, md: 2 },
            boxShadow: "0 8px 24px -4px rgba(15, 23, 42, 0.16)",
            mt: 0.5,
            mb: 2,
            minHeight: { xs: "125px", sm: "135px", md: "132px", lg: "138px" },
          }}
        >
          {/* Left Content */}
          <Box sx={{ maxWidth: { xs: "100%", md: "68%" }, zIndex: 1 }}>
            <Typography
              sx={{
                fontSize: { xs: "0.62rem", sm: "0.68rem", md: "0.74rem" },
                fontWeight: 700,
                textAlign: "left",
                letterSpacing: "0.08em",
                color: "rgba(255, 255, 255, 0.9)",
                textTransform: "uppercase",
                mb: { xs: 0.35, sm: 0.6 },
                fontFamily: '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                textShadow: "0 1px 3px rgba(0, 0, 0, 0.45)",
              }}
            >
              WELCOME BACK, {(localStorage.getItem("userName") || "USER").toUpperCase()}
            </Typography>
            <Typography
              component="h1"
              sx={{
                fontSize: {
                  xs: "0.92rem",
                  sm: "1.08rem",
                  md: "1.25rem",
                  lg: "1.36rem",
                  xl: "1.52rem"
                },
                fontWeight: 750,
                color: "#ffffff",
                lineHeight: { xs: 1.25, sm: 1.3 },
                letterSpacing: "-0.01em",
                textAlign: "left",
                mb: { xs: 0.5, sm: 0.8 },
                fontFamily: '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                textShadow: "0 2px 8px rgba(0, 0, 0, 0.45)",
              }}
            >
              Empowering Laboratories
              <br />
              Through Digital Transformation
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                fontSize: { xs: "0.72rem", sm: "0.80rem", md: "0.86rem", lg: "0.90rem" },
                fontWeight: 650,
                color: "rgba(255, 255, 255, 0.95)",
                letterSpacing: "0.015em",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: { xs: "3px 8px", sm: "4px 10px" },
                textShadow: "0 2px 6px rgba(0, 0, 0, 0.45)",
                mt: 0.3,
              }}
            >
              <span>Accurate Results</span>
              <Box component="span" sx={{ opacity: 0.6, fontSize: "0.85em" }}>•</Box>
              <span>Complete Traceability</span>
              <Box component="span" sx={{ opacity: 0.6, fontSize: "0.85em" }}>•</Box>
              <span>Greater Compliance</span>
            </Typography>
          </Box>

          {/* Right Quote */}
          <Box
            sx={{
              alignSelf: { xs: "flex-end", md: "center" },
              textAlign: "right",
              zIndex: 1,
              pr: { xs: 0, md: 1 },
              mt: { xs: 0.6, md: 0 },
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "0.68rem", sm: "0.78rem", md: "0.88rem", lg: "0.96rem" },
                fontStyle: "italic",
                fontWeight: 500,
                color: "rgba(255, 255, 255, 0.95)",
                lineHeight: { xs: 1.25, sm: 1.35 },
                fontFamily: '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                textShadow: "0 2px 6px rgba(0, 0, 0, 0.6)",
                whiteSpace: "pre-line",
              }}
            >
              {`“Precision today\nfor a safer tomorrow.”`}
            </Typography>
            <Box
              sx={{
                width: { xs: "18px", sm: "24px", md: "28px" },
                height: "2px",
                backgroundColor: "rgba(255, 255, 255, 0.65)",
                ml: "auto",
                mt: { xs: 0.4, sm: 0.6 },
                borderRadius: "2px",
              }}
            />
          </Box>
        </Box>

        {(userType == 1 || userType == 4) ? (
          <>
            {/* Overall Statistics Section */}
            <Box sx={{ mt: 1.5, mb: 3 }}>
              <DashboardSectionHeader
                title="Overall Statistics"
                accentBar
                action={
                  certificateApprovedCount != 0 && moduleAccess.includes(5) && props.rolesInfo?.currentRole?.id == 2 && (
                    <DashboardActionPill
                      to="/certificate/count"
                      label={`Approval Request (${certificateApprovedCount})`}
                      onClick={() => sessionStorage.setItem("searched", "true")}
                    />
                  )
                }
              />

              <Grid container spacing={{ xs: 1.4, sm: 1.8, lg: 2 }}>
                {[
                  {
                    id: "dashboard_clients",
                    label: "Clients",
                    total: overallMonthlyStats.clients.total,
                    value: overallMonthlyStats.clients.current,
                    lastValue: overallMonthlyStats.clients.last,
                    valueLabel: "This Month",
                    icon: GroupIcon,
                    color: "#2563eb",
                    bg: "rgba(37, 99, 235, 0.08)",
                    link: "/master/client",
                  },
                  {
                    id: "dashboard_certificates",
                    label: "Approved Certificates",
                    total: overallMonthlyStats.certs.total,
                    value: overallMonthlyStats.certs.current,
                    lastValue: overallMonthlyStats.certs.last,
                    valueLabel: "This Month",
                    icon: WorkspacePremiumIcon,
                    color: "#7c3aed",
                    bg: "rgba(124, 58, 237, 0.08)",
                    link: "/certificate",
                  },
                  {
                    id: "dashboard_renewal",
                    label: "DUC Renewals",
                    total: overallMonthlyStats.renewals.total,
                    value: overallMonthlyStats.renewals.current,
                    lastValue: overallMonthlyStats.renewals.last,
                    valueLabel: "This Month",
                    lastValueLabel: "Last Month",
                    icon: AutorenewIcon,
                    color: "#0d9488",
                    bg: "rgba(13, 148, 136, 0.08)",
                    link: "/scheduler",
                  },
                  {
                    id: "dashboard_Master_Renewals",
                    label: "Master Renewals",
                    total: overallMonthlyStats.masters.total,
                    value: overallMonthlyStats.masters.current,
                    lastValue: overallMonthlyStats.masters.last,
                    valueLabel: "This Month",
                    lastValueLabel: "Last Month",
                    icon: AutorenewIcon,
                    color: "#ea580c",
                    bg: "rgba(234, 88, 12, 0.08)",
                    link: "/master/masterEQP/count",
                  },
                ].map((metric) => (
                  <CustomCard key={metric.id} metric={metric} />
                ))}
              </Grid>
            </Box>

            {/* Work Report & Recent Inwards */}
            <Grid container spacing={2} sx={{ mb: 3 }} alignItems="stretch">
              <Grid item xs={12} md={(isAdmin || moduleAccess.includes(3)) ? 4.5 : 12} lg={(isAdmin || moduleAccess.includes(3)) ? 4 : 12}>
                <WorkReportWidget
                  performanceData={performanceData}
                  approverPerformanceData={approverPerformanceData}
                  timeframe={workReportTimeframe}
                  onTimeframeChange={(val) => {
                    setWorkReportTimeframe(val);
                    fetchPerformance(val);
                    fetchApproverPerformance(val);
                  }}
                />
              </Grid>
              {(isAdmin || moduleAccess.includes(3)) && (
                <Grid item xs={12} md={7.5} lg={8}>
                  <RecentInwardsWidget inwards={recentInwardsList} />
                </Grid>
              )}
            </Grid>

            {/* Upcoming Due Dates */}
            {(isAdmin || moduleAccess.includes(12)) && (
              <Grid container spacing={2} sx={{ mb: 4 }}>
                <Grid item xs={12}>
                  <UpcomingDueDatesWidget dueDates={upcomingDueDatesList} />
                </Grid>
              </Grid>
            )}
          </>
        ) : userType == 2 ? (
          // Engineer Dashboard
          <>
            {/* Engineer Overview Container Card */}
            <DashboardWidgetCard
              sx={{
                mt: 1.5,
                mb: 2.5,
                height: 'auto !important',
                display: 'block',
                pt: { xs: 1.4, sm: '14px' },
                px: { xs: 1.4, sm: '18px' },
                pb: { xs: 1.4, sm: '16px' },
              }}
            >
              <DashboardSectionHeader
                title="Engineer Overview"
                subtitle="Quick access to assigned calibrations, pending tasks, and renewals"
                mb={1.5}
                action={
                  <>
                    {certificateApprovedCount != 0 && moduleAccess.includes(5) && props.rolesInfo?.currentRole?.id == 2 && (
                      <DashboardActionPill
                        to="/certificate/count"
                        label={`Approval Request (${certificateApprovedCount})`}
                        onClick={() => sessionStorage.setItem("searched", "true")}
                      />
                    )}
                    {props.rolesInfo?.currentRole?.id == 1 && userType == 2 && (
                      <DashboardActionPill
                        to="/datasheet/count"
                        label={`Job Request (${datashheetCalibratedPending})`}
                        color="#3b82f6"
                        hoverColor="#2563eb"
                        onClick={() => sessionStorage.setItem("searched", "true")}
                      />
                    )}
                  </>
                }
              />

              <Grid container spacing={{ xs: 1.4, sm: 1.6, lg: 1.8 }}>
                {[
                  {
                    id: "dashboard_self_jobs",
                    label: "Self Jobs",
                    value: counts.selfJobs || 0,
                    icon: ArticleIcon,
                    color: "#2563eb",
                    bg: "rgba(37, 99, 235, 0.08)",
                    link: "/datasheet?filter=self",
                    gridProps: { xs: 12, sm: 6, md: 4 },
                  },
                  {
                    id: "dashboard_assigned_jobs",
                    label: "Assigned Jobs",
                    value: counts.assignedJobs || 0,
                    icon: GroupIcon,
                    color: "#4f46e5",
                    bg: "rgba(79, 70, 229, 0.08)",
                    link: "/datasheet?filter=assigned",
                    gridProps: { xs: 12, sm: 6, md: 4 },
                  },
                  {
                    id: "dashboard_pending_jobs",
                    label: "Pending Jobs",
                    value: counts.pendingJobs || 0,
                    icon: HelpIcon,
                    color: "#f59e0b",
                    bg: "rgba(245, 158, 11, 0.08)",
                    link: "/datasheet?filter=pending",
                    gridProps: { xs: 12, sm: 6, md: 4 },
                  },
                  {
                    id: "dashboard_completed_jobs",
                    label: "Completed Jobs",
                    value: counts.completedJobs || 0,
                    icon: CardGiftcardOutlinedIcon,
                    color: "#16a34a",
                    bg: "rgba(22, 163, 74, 0.08)",
                    link: "/datasheet?filter=completed",
                    gridProps: { xs: 12, sm: 6, md: 4 },
                  },
                  {
                    id: "dashboard_duc_renewal",
                    label: "DUC Renewal",
                    value: counts.engineerRenewals || 0,
                    icon: RotateLeftOutlinedIcon,
                    color: "#0891b2",
                    bg: "rgba(8, 145, 178, 0.08)",
                    link: "/scheduler?filter=engineerRenewals",
                    gridProps: { xs: 12, sm: 6, md: 4 },
                  },
                  {
                    id: "dashboard_master_renewals",
                    label: "Master Renewals",
                    value: counts.masterRenewalCount || 0,
                    icon: RotateLeftOutlinedIcon,
                    color: "#10b981",
                    bg: "rgba(16, 185, 129, 0.08)",
                    link: "/master/masterEQP/count",
                    gridProps: { xs: 12, sm: 6, md: 4 },
                  },
                ].map((metric) => (
                  <CustomCard key={metric.id} metric={metric} />
                ))}
              </Grid>
            </DashboardWidgetCard>

            {/* Jobs Summary Container Card */}
            <DashboardWidgetCard
              sx={{
                mt: 2.5,
                mb: 3,
                height: 'auto !important',
                display: 'block',
                pt: { xs: 2, sm: '20px' },
                px: { xs: 2, sm: '24px' },
                pb: { xs: 2, sm: '22px' },
                textAlign: 'left',
              }}
            >
              {/* Header */}
              <DashboardSectionHeader
                title="Jobs Summary"
                subtitle="Workload distribution and status breakdown for calibration jobs"
                mb={2.5}
                action={
                  <Box
                    sx={{
                      px: { xs: 1.2, sm: 1.5 },
                      py: { xs: 0.5, sm: 0.6 },
                      borderRadius: '20px',
                      bgcolor: '#eff6ff',
                      border: '1px solid #dbeafe',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 0.8,
                      flexShrink: 0,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#2563eb', flexShrink: 0 }} />
                    <Typography sx={{ fontSize: { xs: '0.72rem', sm: '0.78rem' }, fontWeight: 700, color: '#1e40af', whiteSpace: 'nowrap' }}>
                      {(counts.selfJobs || 0) + (counts.assignedJobs || 0)} Total Assigned
                    </Typography>
                  </Box>
                }
              />

              <Grid container spacing={3} alignItems="stretch">
                {/* Left Chart Card */}
                <Grid item xs={12} lg={7} md={6}>
                  <Box
                    sx={{
                      p: { xs: 2, sm: 2.5 },
                      borderRadius: '14px',
                      bgcolor: '#f8fafc',
                      border: '1px solid #e2e8f0',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: 'left',
                    }}
                  >
                    <Box sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      alignItems: { xs: 'flex-start', sm: 'center' },
                      justifyContent: 'space-between',
                      gap: { xs: 1, sm: 2 },
                      mb: 1.8,
                      textAlign: 'left',
                      width: '100%',
                    }}>
                      <Typography sx={{ fontSize: '0.82rem', fontWeight: 700, color: '#334155', textTransform: 'uppercase', letterSpacing: '0.04em', textAlign: 'left' }}>
                        Workload Distribution
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                          <Box sx={{ width: 10, height: 10, borderRadius: '3px', bgcolor: '#1976d2', flexShrink: 0 }} />
                          <Typography sx={{ fontSize: '0.74rem', color: '#64748b', fontWeight: 600, whiteSpace: 'nowrap' }}>Completed</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                          <Box sx={{ width: 10, height: 10, borderRadius: '3px', bgcolor: 'rgba(189, 189, 189, 0.6)', flexShrink: 0 }} />
                          <Typography sx={{ fontSize: '0.74rem', color: '#64748b', fontWeight: 600, whiteSpace: 'nowrap' }}>Pending</Typography>
                        </Box>
                      </Box>
                    </Box>

                    <Box sx={{ width: '100%', height: 280, position: 'relative', overflow: 'hidden' }}>
                      <BarGraph data={engineerBarData} height="280px" options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: { display: false },
                          title: { display: false },
                        },
                        scales: {
                          x: {
                            stacked: true,
                            grid: { display: false },
                          },
                          y: {
                            stacked: true,
                            beginAtZero: true,
                            grid: { color: 'rgba(0,0,0,0.05)' },
                          },
                        },
                        barThickness: 46,
                        categoryPercentage: 0.8,
                        barPercentage: 0.9,
                      }} />
                    </Box>
                  </Box>
                </Grid>

                {/* Right Stat Metrics */}
                <Grid item xs={12} lg={5} md={6}>
                  <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", gap: 2, textAlign: 'left' }}>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#334155", textTransform: 'uppercase', letterSpacing: '0.04em', mb: 1.5, textAlign: 'left' }}>
                        Overview & Metrics
                      </Typography>

                      <Grid container spacing={1.8}>
                        {[
                          {
                            label: "Total Jobs",
                            value: (counts.selfJobs || 0) + (counts.assignedJobs || 0),
                            color: "#2563eb",
                            bg: "#f0f7ff",
                            borderColor: "#bfdbfe",
                            icon: ArticleIcon,
                          },
                          {
                            label: "Self Jobs",
                            value: counts.selfJobs || 0,
                            color: "#4f46e5",
                            bg: "#f5f3ff",
                            borderColor: "#ddd6fe",
                            icon: ArticleIcon,
                          },
                          {
                            label: "Assigned Jobs",
                            value: counts.assignedJobs || 0,
                            color: "#0891b2",
                            bg: "#ecfeff",
                            borderColor: "#a5f3fc",
                            icon: GroupIcon,
                          },
                          {
                            label: "Completed Jobs",
                            value: counts.completedJobs || 0,
                            color: "#16a34a",
                            bg: "#f0fdf4",
                            borderColor: "#bbf7d0",
                            icon: CardGiftcardOutlinedIcon,
                          },
                        ].map((stat, i) => {
                          const IconComponent = stat.icon;
                          return (
                            <Grid item xs={6} key={i}>
                              <Box
                                sx={{
                                  p: 2,
                                  borderRadius: "14px",
                                  bgcolor: stat.bg,
                                  border: `1px solid ${stat.borderColor}`,
                                  transition: 'all 0.2s ease',
                                  textAlign: 'left',
                                  '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                                  },
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                                  <Typography
                                    sx={{
                                      fontSize: "0.72rem",
                                      fontWeight: 700,
                                      color: "#64748b",
                                      textTransform: "uppercase",
                                      letterSpacing: "0.04em",
                                      textAlign: 'left',
                                    }}
                                  >
                                    {stat.label}
                                  </Typography>
                                  <Box
                                    sx={{
                                      width: 28,
                                      height: 28,
                                      borderRadius: '8px',
                                      bgcolor: '#ffffff',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                    }}
                                  >
                                    <IconComponent sx={{ fontSize: 16, color: stat.color }} />
                                  </Box>
                                </Box>
                                <Typography sx={{ fontSize: "1.65rem", fontWeight: 800, color: stat.color, lineHeight: 1.1, textAlign: 'left' }}>
                                  {stat.value}
                                </Typography>
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Box>

                    {/* Bottom Status Note */}
                    <Box
                      sx={{
                        p: 1.8,
                        borderRadius: "12px",
                        bgcolor: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        textAlign: 'left',
                      }}
                    >
                      <Box
                        sx={{
                          width: 6,
                          height: 28,
                          bgcolor: "#3b82f6",
                          borderRadius: "4px",
                          flexShrink: 0,
                        }}
                      />
                      <Typography sx={{ fontSize: "0.8rem", color: "#475569", lineHeight: 1.4, textAlign: 'left' }}>
                        Real-time status of assigned calibration tasks and self-managed datasheets.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </DashboardWidgetCard>
          </>
        ) : null}
      </div>
    </EditWrap>
  );
}
